import { companyProfileSchema } from './company-profile';

import type { CompanyProfile } from './company-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type UpdateCompanyProfile = (companyProfile: CompanyProfile) => Promise<Result<CompanyProfile, unknown>>;

export const createUpdateCompanyProfile = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UpdateCompanyProfile => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (companyProfile) => {
        return validatingCobrainerApiFetcher.patchJson(companyProfileSchema, {
            pathname: `/company-profile`,
            payload: companyProfile,
        });
    };
};
